import { Box } from '@mui/material'
import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import AmountChart from '../component/sales-stats/AmountChart'
import SearchBar from '../component/sales-stats/SearchBar'
import { Navbar } from '../component/shared/Navbar'
import { PageContainer } from '../component/styled/PageContainer'
import { TYREHUB } from '../constant/htg-companies'

export const SalesStatsScreen = () => {
  const [query, setQuery] = useState({
    year: new Date().getFullYear(),
    startMonth: new Date().getMonth() + 1,
    endMonth: new Date().getMonth() + 1,
    htgCompany: TYREHUB,
  })

  return (
    <PageContainer>
      <Box sx={{ p: { xs: 1 } }} mb={10}>
        <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
          <title>Revenue Dashboard</title>
        </Helmet>
        <Navbar />
        <SearchBar data={query} setData={setQuery} />
        <AmountChart query={query} />
      </Box>
    </PageContainer>
  )
}
